import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { connect } from 'react-redux';
import {
    bltHomeSelect
} from "../../../redux/selector/bltHomeSelector"
import { BLTNavigationTop } from '../BLTCommon/BLTNavigationTop'
import './BLTHomeSearch.styles.scss'
import BLTHomeFilter from '../BLTHome/BLTHomeFilter'
import { useLocation } from 'react-router';
import { BLTSearchResults } from './BLTSearchResults';
import { Pagination } from '../../../components/Pagination/Pagination';
import { fetchSearchResponse } from '../../../redux/slice/bltHomeSlice';
import { LICENCE_SUB_TYPE_ALL } from '../../../app/constants';

function BLTHomeSearchPage(props) {

    const {dispatch} = props
    const MAX_NUMBER_OF_RECORDS_PER_PAGE = 50

    const [searchResults, setSearchResults] = useState([])
    const [paginationData, setPaginationData] = useState({})

    const [page, setPage] = useState(paginationData?.currentPage || 1);

    const location = useLocation();

    const params = useMemo(() => {
        const urlQuery = new URLSearchParams(location.search);
        return {
            licenceTypeText: urlQuery.get("licenceTypeText"),
            licenceTypeOption: urlQuery.get("licenceTypeOption"),
            sortType: urlQuery.get("sortType"),
        }
    }, [location])

    const searchApplications = useCallback(() => {

        const { licenceTypeText, licenceTypeOption, sortType } = params;

        //No search text and app type filter is ALL
        if (!licenceTypeText && licenceTypeOption === LICENCE_SUB_TYPE_ALL) { 
            return 
        }

        let searchParams = {
            licenceTypeText : licenceTypeText,
            page : page,
            numberOfRecords : MAX_NUMBER_OF_RECORDS_PER_PAGE,
            licenceTypeOption : licenceTypeOption ? licenceTypeOption : null
        }

        if(sortType) {
            searchParams.sortType = sortType;
        }

        const promiseArray = []

        // fetching from regular table
        promiseArray.push(dispatch(fetchSearchResponse(searchParams)))

        // fetching from archive table
        promiseArray.push(dispatch(fetchSearchResponse(searchParams, true)))
        
        Promise.all(promiseArray).then(results => {
            const mergedResponse = []
            let paginationData = null
            results.forEach(searchResponse => {
                if(searchResponse?.businessLicenceList?.length)
                    mergedResponse.push(...searchResponse.businessLicenceList)

                // which response has more number of records and set that as pagination
                if(!paginationData) {
                    paginationData = searchResponse.paginationData
                } else {
                    if(paginationData.totalRecords < searchResponse.paginationData?.totalRecords) {
                        paginationData = searchResponse.paginationData
                    }
                }
            })
            setSearchResults(mergedResponse.map((licence) => ({ ...licence, licenceType: params.licenceTypeOption })))
            setPaginationData(paginationData)
        })

        // dispatch(fetchSearchResponse(searchParams))
        //     .then(searchResponse => {
        //         if(searchResponse) { 
        //             setSearchResults(searchResponse.businessLicenceList?.map((licence) => ({ ...licence, licenceType: params.licenceTypeOption })))
        //             setPaginationData(searchResponse.paginationData)
        //         }
        //     })
    }, [dispatch, params, page])


    useEffect(() => {
        
        // const { licenceTypeText, licenceTypeOption } = params;

        //No search text and app type filter is ALL
        // if (!licenceTypeText && licenceTypeOption === LICENCE_SUB_TYPE_ALL) { 
        //     return 
        // }

        searchApplications()
    }, [searchApplications])


    return (
        <>
            <BLTNavigationTop />
            <div className={"container"}>
                <div className="row">
                    <div className="col-12">
                        <h1>Search</h1>
                    </div>
                    <BLTHomeFilter 
                        presetLicenceTypeOption={params.licenceTypeOption}
                        presetSearchText={params.licenceTypeText}
                        presetSortType={params.sortType} 
                        setPage={setPage}
                    />
                    <div className="botomMarginMedium">&nbsp;</div>
                    <BLTSearchResults
                        {...props}
                        headers={bltHomeSelect.queueHeaders}
                        searchResults={searchResults}
                        paginationData={paginationData}
                    />
                </div>
                <div className="row searchPaginationContainer">
                    <div className="col-12">
                        <Pagination
                            totalPages={paginationData?.totalRecords ? Math.ceil(paginationData?.totalRecords / MAX_NUMBER_OF_RECORDS_PER_PAGE) : 0}
                            currentPage={page ?? 1}
                            onPageChange={(pageNum) => {
                                setPage(pageNum)
                            }}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default connect(bltHomeSelect)(BLTHomeSearchPage)
